import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const fetchAllFinancialTransactions = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.financialTransactions
        .fetchAllFinancialTransactions(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_FINANCIAL_TRANSACTIONS_FAILED,
              reject: actionTypes.FETCH_FINANCIAL_TRANSACTIONS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_FINANCIAL_TRANSACTIONS_LOADING);
  const success = res => action(actionTypes.FETCH_FINANCIAL_TRANSACTIONS_SUCCESS, res);

  return request();
};
export const fetchFinancialTransactionDetails = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.financialTransactions
        .fetchFinancialTransactionDetails(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_FINANCIAL_TRANSACTION_DETAILS_FAILED,
              reject: actionTypes.FETCH_FINANCIAL_TRANSACTION_DETAILS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_FINANCIAL_TRANSACTION_DETAILS_LOADING);
  const success = res => action(actionTypes.FETCH_FINANCIAL_TRANSACTION_DETAILS_SUCCESS, res);

  return request();
};

export const fetchAllUserFinancialTransactions = (userId, query) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.financialTransactions
        .fetchAllUserFinancialTransactions(userId, query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_USER_FINANCIAL_TRANSACTIONS_FAILED,
              reject: actionTypes.FETCH_USER_FINANCIAL_TRANSACTIONS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_USER_FINANCIAL_TRANSACTIONS_LOADING);
  const success = res => action(actionTypes.FETCH_USER_FINANCIAL_TRANSACTIONS_SUCCESS, res);

  return request();
};

export const getConstantReservesReportRequest = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.financialTransactions
        .getConstantReservesReportRequest(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_CONSTANT_RESERVES_REPORT_FAILED,
              reject: actionTypes.GET_CONSTANT_RESERVES_REPORT_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_CONSTANT_RESERVES_REPORT_LOADING);
  const success = res => action(actionTypes.GET_CONSTANT_RESERVES_REPORT_SUCCESS, res);

  return request();
};

export const getRechargeChairsReportRequest = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.financialTransactions
        .getRechargeChairsReportRequest(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_RECHARGE_CHAIRS_REPORT_FAILED,
              reject: actionTypes.GET_RECHARGE_CHAIRS_REPORT_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_RECHARGE_CHAIRS_REPORT_LOADING);
  const success = res => action(actionTypes.GET_RECHARGE_CHAIRS_REPORT_SUCCESS, res);

  return request();
};

export const getPurchasePackagesReport = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.financialTransactions
        .getPurchasePackagesReport(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_PURCHASE_PACKAGES_REPORT_FAILED,
              reject: actionTypes.GET_PURCHASE_PACKAGES_REPORT_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_PURCHASE_PACKAGES_REPORT_LOADING);
  const success = res => action(actionTypes.GET_PURCHASE_PACKAGES_REPORT_SUCCESS, res);

  return request();
};
